import { render, staticRenderFns } from "./BrandsMenu.vue?vue&type=template&id=55c924c1&"
import script from "./BrandsMenu.vue?vue&type=script&lang=js&"
export * from "./BrandsMenu.vue?vue&type=script&lang=js&"
import style0 from "./BrandsMenu.vue?vue&type=style&index=0&id=55c924c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports